import { useState } from 'react';
import { Download, Smartphone } from 'lucide-react';
import './SaveContact.css';

const SaveContact = ({ person }) => {
  const [feedback, setFeedback] = useState('');

  const generateVCard = () => {
    // Create vCard format (compatible with all phones)
    // For FidLogic IT Solutions, don't include ORG field
    const isFidlogic = person.name === 'FidLogic IT Solutions';
    
    let vcard = `BEGIN:VCARD
VERSION:3.0
FN:${person.name}
TITLE:${person.designation}`;


if (person.name.includes(' ')) {
  const { firstName, lastName } = parseName(person.name);
  vcard += `
N:${lastName};${firstName};;;`;
    } else {
      vcard += `
N:;${person.name}`;
    }


    // Seperate fields for FidLogic vs Personal contacts
    if (!isFidlogic && person.company) { // Personal contact
      vcard += `
ORG:${person.company}`;
    } else { // FidLogic contact
      vcard += `
NOTE:${person.company}`;
    }

    vcard += `
EMAIL:${person.email}
TEL:${person.phone}
URL:https://${person.website}
END:VCARD`;

    return vcard;
  };

  // Function to parse the name into first and last components
  const parseName = (fullName) => {
    const parts = fullName.trim().split(' ');
    const firstName = parts.shift() || ''; // Get the first part
    const lastName = parts.join(' ');     // Join the remaining parts

    return { firstName, lastName };
};

  const downloadVCard = () => {
    const vcard = generateVCard();
    const element = document.createElement('a');
    const file = new Blob([vcard], { type: 'text/vcard' });
    element.href = URL.createObjectURL(file);
    element.download = `${person.name.replace(/\s+/g, '_')}.vcf`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    
    // No success feedback - only show on errors
  };

  const saveToPhoneWeb = () => {
    const vcard = generateVCard();
    
    // Create a data URL
    const dataUrl = 'data:text/vcard;charset=utf-8,' + encodeURIComponent(vcard);
    
    // Create link and trigger download
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = `${person.name.replace(/\s+/g, '_')}.vcf`;
    link.click();

    // No success feedback - only show on errors
  };

  const handleSaveClick = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIPhone = /iphone|ipod/.test(userAgent);
    const isAndroid = /android/.test(userAgent);

    if (isIPhone) {
      // For iPhone, use web approach
      saveToPhoneWeb();
    } else if (isAndroid) {
      // For Android, use download approach
      downloadVCard();
    } else {
      // For desktop/other devices
      downloadVCard();
    }
  };

  return (
    <div className="save-contact-container">
      <button 
        className="save-contact-btn"
        onClick={handleSaveClick}
        title="Save this contact to your phone"
      >
        <Smartphone size={20} />
        <span>Save Contact</span>
      </button>
      
      {feedback && (
        <div className="save-feedback">
          <Download size={16} />
          <span>{feedback}</span>
        </div>
      )}
    </div>
  );
};

export default SaveContact;
